//登录模板
<template>
  <div class="login">
    <div class="left_login">
      <img :src="oemImg" alt="OEM用户验证" />
      <ul class="input_sn">
        <li>序列号（SN）或设备编号：</li>
        <li class="input">
          <input
            type="text"
            maxlength="30"
            minlength="1"
            v-model="val"
            @keyup.enter="checking()"
            placeholder="请输入SN号或设备编号"
          />
        </li>
        <li>
          &nbsp&nbsp&nbsp&nbsp
        </li>
        <li class="input">
          <input
            type="text"
            maxlength="4"
            minlength="4"
            v-model="input_code"
            placeholder="请输入右侧验证码"
          />
        </li>
        <li>
          <button @click="createCode()" style="width: 70px; height: 30px; background: #006cc2; color: white">{{g_code}}</button>
        </li>
        <li class="tips" v-if="tipsShow">
          *
          <span>{{tipsContent}}</span>
        </li>
      </ul>
      <button :disabled="input_code.length != 4 || val.length == 0" @click="checking()">验证</button>
      <ul>
        <li>
          <div align="left" style="font-size:12px; margin-left:300px; height: 50px; margin-top: 20px">
            序列号（SN）：神州网信产品标签上的序列号&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp设备编号：电脑的设备编号，一般印刷在你的电脑上，或者通过激活客户端读取
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { post } from "@/util/http";
export default {
  name: "login",
  beforeCreate: function() {
    if (
      sessionStorage.getItem("isLogin") === "true" &&
      sessionStorage.getItem("oemToken")
    ) {
      this.$router.push({
        name: "public",
        params: {
          id: "oem"
        }
      });
    }
  },
  watch: {},
  data() {
    return {
      input_code: '', //输入的验证码
      g_code: '', //生成的验证码
      oemImg: "/static/img/OEM.png",
      isDisabled: true,
      val: "",
      tipsShow: false,
      tipsContent: "格式错误"
    };
  },
  created(){
    this.createCode();
  },
  methods: {
    createCode(){
      let code = "";
      let codeLength = 4;//验证码的长度
      let random = new Array(0,1,2,3,4,5,6,7,8,9,'A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R',
        'S','T','U','V','W','X','Y','Z');//随机数
      for(var i = 0; i < codeLength; i++) {
        //循环操作
        var index = Math.floor(Math.random()*36);//取得随机数的索引（0~35）
        code += random[index];//根据索引取得随机数加到code上
      }
      this.g_code = code;//把code值赋给验证码
    },
    //发送验证
    checking: function() {
      let reg = /^[0-9a-zA-Z]*$/g;
      let self = this;
      let len = self.val.length;
      self.tipsShow = false;

      if (self.input_code.toUpperCase() != self.g_code ) {
        self.tipsContent = "请输入正确的验证码";
        self.tipsShow = true;
        return;
      }

      if (len === 0) {
        return false;
      } else {
        self.isDisabled = true;
        // if (!reg.test(self.val)) {
        //   self.tipsContent = "格式不正确，请检查重试";
        //   self.tipsShow = true;
        // } else {
          post("download/oem/login/", {
            sn: self.val.toUpperCase()
          }).then(
            res => {
              sessionStorage.setItem("isLogin", true);
              // sessionStorage.setItem("oemToken", res.token);
              sessionStorage.setItem("is_sn", res.is_sn);
              sessionStorage.setItem("device_sn", res.device_sn);
              sessionStorage.setItem("sn", res.sn);
              self.tipsShow = false;
              self.$router.push({
                name: "oemPublic",
                params: {
                  id: "oem"
                }
              });
            },
            err => {
              self.tipsContent =
                "没有和该序列号或设备编号对应的镜像，请联系您的电脑厂商。";
              self.tipsShow = true;
              self.isDisabled = false;
            }
          );
        // }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/oems/LoginOem.vue